import React, { useEffect } from 'react';
import { BitMap, Color } from './bitmap';
import { useBitMap2Image } from './utils';
import { BW2x2_DATA_URL } from '../bins';

function useDebounce<T>(value: T, delay: number) {
  const [debouncedValue, setDebouncedValue] = React.useState(value)
  React.useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])
  return debouncedValue
}

export function ColorBitMapRender(props: { bitMap: BitMap<Color>, size?: number }) {
  const { bitMap } = props;
  const size = props.size ?? 1;
  const ref = React.createRef<HTMLCanvasElement>();
  // const _bitMap = useDebounce(bitMap, 1000);
  // useBitMap2Image(ref, _bitMap, size);
  useEffect(() => {
    if (ref.current) {
      const canvas = ref.current;
      const { width, height } = bitMap;
      canvas.width = width * size;
      canvas.height = height * size;
      const ctx = canvas.getContext('2d');
      for (let x = 0; x < width; x++)
        for (let y = 0; y < height; y++) {
          const c = bitMap.get(x, y);
          const { r, g, b, a } = c;
          ctx.fillStyle = `rgba(${r},${g},${b},${a})`;
          ctx.fillRect(x * size, y * size, size, size);
        }
    }
  }, [bitMap])

  return (
    <canvas
      ref={ref}
      style={{
        width: bitMap.width * size,
        height: bitMap.height * size,
        backgroundColor: '#fff',
        backgroundImage: `url(${BW2x2_DATA_URL})`,
        backgroundRepeat: 'repeat',
        backgroundSize: 8,
      }}
    />
  )
}



